import {Dto} from "common";

export class ForceAndTimePacket extends Dto {
    public force: number;
    public time: number;

    deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }
}
